import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";

const EASE = [0.16, 1, 0.3, 1] as const;

/** Reveal al scroll — soft, editoriale, una sola volta. */
export const Reveal = ({
  children,
  delay = 0,
  y = 28,
  className,
  testid,
}: {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  testid?: string;
}) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      data-testid={testid}
      initial={reduce ? { opacity: 1 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

/** Riga del titolo hero: reveal mascherato riga-per-riga al caricamento. */
export const HeroLine = ({
  children,
  index = 0,
  className,
}: {
  children: ReactNode;
  index?: number;
  className?: string;
}) => {
  const reduce = useReducedMotion();
  return (
    <span className="hero-mask">
      <motion.span
        className={`block ${className ?? ""}`}
        initial={reduce ? { y: 0 } : { y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.95, delay: 0.18 + index * 0.14, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};
